<template lang="pug">
include ../pug/svg
section#peoplelist
	div#ctrl
		div
			Search(v-model:search="search")
			Filter(v-if="canManagePeople" id="statusRole" label="Role" title="Role" :options="roleFilters" v-model:selected="roleFilter")
			Filter(id="statusFilter" label="Status" title="Status" :options="statusFilters" v-model:selected="statusFilter")
			Filter(v-if="groupFilters.length" id="groupFilter" :label="terminology('user','group','singular')" :title="terminology('user','group','singular')" :options="groupFilters" v-model:selected="groupFilter")
			button.but.circ.plus.text(v-if="canManagePeople" type="button" @click="toggleModal(true)" :disabled="licenseLimit && !licenseUnused")
				span Add {{terminology('user','user','plural')}}
				+svg(svg-filename="iconPlus" aria-hidden="true" alt="Add icon")
	div.wrapper
		div.c1.listbg
			//-div.group
				FieldText(name="group2" label="Group" v-model="group2" :required="true")
			ul.list
				li.person(v-for="(user, index) in filteredUsers" :key="user.id" :user="user" :index="index" @mouseenter="previewIndex=index" :class="{active:previewIndex===index}")
					picture.user(v-if="user.profileUrl" :class="{online:user.online}")
						img(:src="user.profileUrl" width="40" height="40" :alt="user.fullName")
					span.user(v-else :class="{online:user.online}") {{user.initials}}
					div.hgroup
						h2 {{user.fullName}}
						h3 {{terminology('user', user.userOrganisations[0].role.slug ,'singular')}} / {{user.userOrganisations[0].status}}
					a.arrow View Individual
						+svg(svg-filename='iconArrow')
					AppLink.but.sec(v-if="user.id===usr.id" :to="{name:'ManageAccountProfile'}") {{terminology('interface','manage','singular')}} Profile
					div.butmore(v-else-if="canManagePeople")
						AppLink(:to="{name:'ManagePeopleUserProfile', params:{userId:user.id}}") {{terminology('interface','manage','singular')}} Profile
						button.but(type="button" aria-haspopup="true" aria-controls="" @mouseenter="showTint(),setMenu($event)" @mouseleave="hideTint") More
							+svg(svg-filename="iconMore" aria-hidden="true" alt="More icon")
						nav.menu(@mouseenter="showTint" @mouseleave="hideTint")
							div.bar
								+svg(svg-filename="iconMore" aria-hidden="true")
								button.but(type="button") Close
									+svg(svg-filename="iconClose")
							ul
								//-li
									AppLink(:to="{name:'ManagePeopleUserOverview', params:{userId:user.id}}") View Dashboard
								//-li
									AppLink(:to="{name:'ManagePeopleUserLearning', params:{userId:user.id}}") View Learning
								//-li
									AppLink(:to="{name:'ManagePeopleUserActivity', params:{userId:user.id}}") View Activity
								//-li(v-if="user.userOrganisations[0].role.slug === 'mentor' && org.assignmentIndividual && !org.assignmentAuto")
								li(v-if="user.userOrganisations[0].role.slug === 'mentor' && org.assignmentIndividual")
									AppLink(:to="{name:'ManagePeopleUserAssignment', params:{userId:user.id}}") {{terminology('user','learner','singular')}} Assignment									
								li(v-if="user.userOrganisations[0].status !== 'archived'")
									a(v-if="user.userOrganisations[0].status === 'suspended'" @click="unsuspendUser(user)") Unsuspend Account
									a(v-else @click="suspendUser(user)") Suspend Account
								li
									a(v-if="user.userOrganisations[0].status === 'archived'" @click="unarchiveUser(user)") Unarchive Account
									a(v-else @click="archiveUser(user)").bin Archive Account
										+svg(svg-filename="iconBin" aria-hidden="true" alt="Bin icon")
		div.c2.sticky(v-if="previewUser")
			div.preview.license(v-if="licenseLimit")
				div.head
					h4 User Licenses
					//-button.but.sec Add Licenses
				div.body
					table.numeric
						tr
							th Allocation
							th Used
							th Unused
						tr
							td {{licenseLimit}}
							td {{licenseUsed}}
							td {{licenseUnused}}
			div.preview
				div.head
					h4 {{previewUser.fullName}}
					h6(v-if="previewUser.online") Online
					h6(v-else) Offline
				div.body
					picture.user(v-if="previewUser.profileUrl" :class="{online:previewUser.online}")
						img(:src="previewUser.profileUrl" width="40" height="40" :alt="previewUser.fullName")
					span.user(v-else :class="{online:previewUser.online}") {{previewUser.initials}}
					table.column
						tr
							th Status
							td.ucfirst {{previewUser.userOrganisations[0].status}}
						tr
							th Role
							td {{terminology('user', previewUser.userOrganisations[0].role.slug ,'singular')}}
						//-tr
							th Joined
							td(v-if="previewUser.verified") {{previewUser.verified}}
							td(v-else) -
						tr
							th Mobile
							td(v-if="previewUser.mobile")
								a(:href="'tel:'+previewUser.mobile") {{previewUser.mobile}}
							td(v-else) -
						tr
							th(v-if="previewUser.email.includes('@')") Email
							th(v-else) Username
							td
								a(:href="'mailto:'+previewUser.email") {{previewUser.email}}
						tr
							th Position
							td(v-if="previewUser.position") {{previewUser.position}}
							td(v-else) -
						tr.pic(v-if="previewUser.userOrganisations[0].role.slug === 'learner'")
							th Assigned {{terminology('user','mentor','singular',true)}}
							td(v-if="assignedMentor(previewUser)")
								picture.user(v-if="assignedMentor(previewUser).profileUrl" :class="{online:assignedMentor(previewUser).online}")
									img(:src="assignedMentor(previewUser).profileUrl" width="40" height="40" :alt="assignedMentor(previewUser).fullName")
								a(v-if="false") {{assignedMentor(previewUser).fullName}}
								span(v-else) {{assignedMentor(previewUser).fullName}}
							td(v-else) N/A
						tr
							th {{terminology('user','group','plural')}}
							td(v-if="userGroups(previewUser).length")
								span.group(v-for="userGroup in userGroups(previewUser)") {{userGroup.organisationGroup.name}}
							td(v-else) -
					ul.social
						li(v-if="previewUser.socialLinkedin")
							a(href="{{previewUser.socialLinkedin}}" target="_blank") Linkedin
								+svg(svg-filename='iconLinkedin')
						li(v-if="previewUser.socialTwitter")
							a(href="{{previewUser.social.socialTwitter}}" target="_blank") Twitter
								+svg(svg-filename='iconTwitter')
						li(v-if="previewUser.socialFacebook")
							a(href="{{previewUser.socialFacebook}}" target="_blank") Facebook
								+svg(svg-filename='iconFacebook')
	div.modal.medium.center(:class="{active:showModal}")
		div.bar
			+svg(svg-filename="iconMore" aria-hidden="true")
			span Add {{terminology('user','user','plural')}}
			button.but(type="button" @click="toggleModal(false)") Close
				+svg(svg-filename="iconClose")
		div.tog
			//-button.but(type="button" :class="{on:!csvImport}" @click="csvImport=false") Form Entry
			//-button.but(type="button" :class="{on:csvImport}" @click="csvImport=true") CSV Import
			button.but(type="button" :class="{on:!csvImport}" @click="toggleCsv(false)") Form Entry
			button.but(type="button" :class="{on:csvImport}" @click="toggleCsv(true)") CSV Import

		div.body
			Form(ref="formUsers" :validation-schema="userSchema" v-slot="{ errors, isSubmitting, values, meta }" @submit="addUsers")
				div.field
					Field(name="from" as="select" placeholder="Unsupplied" autocomplete="off" :validateOnInput="false" :class="{empty:!values.from}")
						option(value="" :selected="!values.from") {{hqThinkHub.label}}
						optgroup(:label="terminology('user','user','plural')")
							option(v-for="(option, index) in emailUsers" :value="option.email" :selected="values.from?.email===option.email") {{option.label}}
					label Invite From
					+svg(svg-filename="iconArrow" aria-hidden="true" alt="Arrow icon")
				fieldset.fgroup
					template(v-if="csvImport")
						div.drop.csv.req(:class="{data:csvData}")
							+svg(svg-filename="iconUpload")
							h2.err(v-if="errors.csv") CSV Error&hellip;
							h2.err(v-else-if="csvData") Valid CSV&hellip;
							h2(v-else) CSV Import
							h3.err(v-if="errors.csv") {{errors.csv}}
							h3.err(v-else-if="csvData") {{csvData.length}} contacts will be invited to join your organisation
							h3(v-else) Drag your .csv file to import {{terminology('user','user','plural')}}.
							a(href="/csv/csv-upload-people-template.csv" target="_blank") Download Import Template (CSV)
							span (max size of 5 MB)
							Field(ref="csvInput" name="csv" type="file" @change="onCsvChange" @click="csvInputKey++" :key="csvInputKey")
					template(v-else)
						FieldText(name="assignmentIndividual" type="hidden" v-model="org.assignmentIndividual")
						FieldText.c2(name="forename" label="Forename" v-model="forename" :required="true" :errors="errors")
						FieldText.c2(name="surname" label="Surname" v-model="surname" :required="true" :errors="errors")
						FieldText.c2(name="email" :label="emailLabel" v-model="email" :required="true" :errors="errors")
						FieldSelect.c2(name="roleId" label="Role" v-model="roleId" :options="userRoles" :required="true" :errors="errors")
						FieldSuggest(name="group" label="Group" v-model="group" :options="groupFilters" searchMode="startsWith" :setTint="false" :errors="errors")
						FieldSelect(v-if="org.assignmentIndividual&&roleId===6" name="assignment" :label="assignmentLabel" v-model="assignment" :options="mentors" :placeholder="assignmentPlaceholder" :required="true" :errors="errors")
						FieldText(name="allowUsername" type="hidden" v-model="allowUsername")
				div.foot
					span.req Required
					button.but.pri.spinner(type="submit" :class="{spin:isSubmitting||processing}" :disabled="!meta.valid||isSubmitting||!meta.touched||disableInvite") Invite
						+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
					button.but.sec(type="button" @click="toggleModal(false)") Cancel
</template>

<script>
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
//import UserService from '../services/UserService';
import Filter from '../components/Filter';
import Search from '../components/Search';
import FieldText from '../components/FieldText';
import FieldSelect from '../components/FieldSelect';
import FieldSuggest from '../components/FieldSuggest';
	
export default {
	name: 'ManagePeople',
	components: {
		Form,
		Field,
		ErrorMessage,
		Search,
		Filter,
		FieldText,
		FieldSelect,
		FieldSuggest,
	},
	data() {
		const req = 'Required';
		const inv = 'Invalid';
		const csvRoles = ['learner','mentor','admin','owner'];
		
		const userSchema = Yup.object().shape({
			email: Yup.string().when(['csv'], {
				is: (csv) => !csv,
				then: Yup.string().test('emailOrUsername', inv, (email, context) => {
					const {allowUsername} = context.parent;
					
					if (email) {
						if (parseInt(allowUsername)) { // allow usernames
							return email.includes('@') ? Yup.string().email().isValidSync(email) : Yup.string().matches(/^[\w-]+$/).isValidSync(email);
						
						} else { // email only
							return Yup.string().email().isValidSync(email);
						}
					}
					
					return false;
					
				}).required(req).nullable(),
			}),
			forename: Yup.string().when('csv', {
				is: (csv) => !csv,
				then: Yup.string().required(req).nullable(),
			}),
			surname: Yup.string().when('csv', {
				is: (csv) => !csv,
				then: Yup.string().required(req).nullable(),
			}),
			roleId: Yup.string().when('csv', {
				is: (csv) => !csv,
				then: Yup.string().test('usernameRole', 'Must be Learner if not using email', (value) => {
					if (value) {
						return (this.email && this.email.includes('@') || value === '6');
					}
					
					return false;
					
				}).required(req).nullable(),
			}),
			group: Yup.string().when('csv', {
				is: (csv) => !csv,
				then: Yup.string().test('groupTest', 'Accepts letters, numbers and spaces. Multiple groups, seperate with a semicolon.', (value) => {
					if (value) {
						return value.match(/[^\w-\s;]/g) ? false : true;
					}
					
					return true;
					
				}).nullable(),
			}),
			assignment: Yup.string().when(['csv','assignmentIndividual'], {
				is: (csv, assignmentIndividual, roleId) => (!csv && assignmentIndividual > 0 && roleId === 6),
				then: Yup.string().required(req),
				otherwise: Yup.string().nullable(),
			}),
		});
		
		const csvSchema = Yup.object().shape({ // NOTE: nullable not used here as it doesn't work on non-field checks
			email: Yup.string().test('email-or-username', 'invalid email or username', (email, context) => {
				const {allowUsername} = context.parent;
				
				if (email) {
					if (parseInt(allowUsername)) { // allow usernames
						return email.includes('@') ? Yup.string().email().isValidSync(email) : Yup.string().matches(/^[\w-]+$/).isValidSync(email); 
					
					} else { // email only
						return Yup.string().email().isValidSync(email);
					}
				}
				
				return false;
				
			}).required('email missing'),
			forename: Yup.string().required('forename missing'),
			surname: Yup.string().required('surname missing'),
			group: Yup.lazy(value => !value ? Yup.string() : Yup.string().matches(/^[\w\s;]+$/, 'group accepts letters, numbers and spaces, with semicolon separators')),
			assignment: Yup.lazy(value => !value ? Yup.string() : Yup.string().email('invalid assignment')),
			role: Yup.string().test('role', 'invalid role', (value) => {
				// restrict to specified roles or empty
				return (value) ? csvRoles.includes(value) : true;
			}),
		});
		
		return {
			csvRoles,
			organisationGroup: null,
			csvSchema,
			userSchema,
			processing: false,
			showModal: false,
			search: null,
			statusFilters: [
				{value: 'invited', option: 'Invited'},
				{value: 'verified', option: 'Verified'},
				{value: 'suspended', option: 'Suspended'},
				{value: 'expired', option: 'Expired'},
				{value: 'archived', option: 'Archived'},
			],
			statusFilter: null,
			groupFilter: null,
			roleFilter: null,
			previewIndex: 0,
			// add people
			disableInvite: false,
			csvImport: false,
			csvHeaders: {
				// header: required
				email: true,
				forename: true,
				surname:  true,
				group: false,
				role: false,
				assignment: false,
			},
			csvData: null,
			csvInputKey: 0,
			// manual entry fields
			email: null,
			group: null,
			forename: null,
			surname: null,
			roleId: null,
			assignment: null,
			//tempPassword: null,
			hqThinkHub: {
				label: 'thinkhub HQ',
				email: 'hq@thethinkhub.uk',
			},
			idRegex: /^[0-9]+(,[0-9]+)*$/,
		}
	},
	mounted() {
		this.$store.dispatch('gui/setHeader', {
			title: this.terminology('interface', 'manage', 'singular') + ' ' + this.terminology('user','user','plural'),
			backRoute: {
				text: 'Dashboard',
				name: 'Dashboard',
			},			
		});
		
		if (this.$route.query.ids) {
			// validate passed ids
			if (this.$route.query.ids.match(this.idRegex)) {
				this.search = this.$route.query.ids;
			}
		}
		
		this.refreshUsers();		
	},
	computed: {
		canManagePeople() {
			return this.hasFeature('people');
		},
		allowUsername() {
			return this.hasFeature('usernames') ? 1 : 0;
		},
		emailLabel() {
			return this.allowUsername ? 'Email or Username' : 'Email';
		},
		assignmentLabel() {
			return this.terminology('user','mentor','singular') + ' Assignment';
		},
		assignmentPlaceholder() {
			return (this.org.assignmentAuto) ? false: 'Unsupplied';
		},
		fieldType() {
			return (this.email && this.email.includes('@')) ? 'password' : 'text';
		},
		org() {
			return this.$store.state.gui.organisation;
		},
		usr() {
			return this.$store.state.auth.user;
		},
		isMentor() {
			return (this.usr.userOrganisations[0].role.slug === 'mentor');	
		},
		users() {
			// copy store to local (allows list sorting)
			return [...this.$store.state.users.users];
		},
		licenseLimit() {
			return this.org.userLimit;
		},
		licenseUsed() {
			return this.users.length;
		},
		licenseUnused() {
			return this.licenseLimit ? (this.licenseLimit - this.licenseUsed) : null;	
		},
		mentors() {
			return this.users.filter(u => u.userOrganisations[0].role.slug === 'mentor').map(u => {
				return {
					option: u.fullName+' ('+u.email+')',
					value: u.userOrganisations[0].id,
					email: u.email,
				};
			});
		},
		emailUsers() {
			// users that can send invites
			return this.users.filter(
				u => u.userOrganisations[0].role.seniority <= 50 // mentor or above
			).map(u => {
				return {
					label: u.fullName,
					email: u.email,
				};
			});
		},
		userRoles() {
			if (!this.email || !Yup.string().email().isValidSync(this.email)) {
				// restrict username users to learner role
				return this.$store.state.users.userRoles.filter(r => r.id === 6).map(r => {
					return {
						value: r.id,
						option: this.terminology('user', r.slug, 'singular'),
					};
				});
				
			}
			
			// prevent auth user asigning role higher than their own
			const authSeniority = this.usr.userOrganisations[0].role.seniority;
			
			return this.$store.state.users.userRoles.filter(r => r.seniority >= authSeniority).map(r => {
				return {
					value: r.id,
					option: this.terminology('user', r.slug, 'singular'),
				};
			});
		},
		roleFilters () {
			return this.$store.state.users.userRoles.filter(r => r.id !== 1).map(r => {
				return {
					value: r.id,
					option: this.terminology('user', r.slug, 'singular'),
					slug: r.slug,
				};
			});
		},
		/*orgEmails() {
			const org = this.org;
			let emails = [];
			
			if (org.emailGeneral) {
				emails.push({
					email: org.emailGeneral,
					label: 'General',
				});
			}
			
			if (org.emailSales) {
				emails.push({
					email: org.emailSales,
					label: 'Sales',
				});
			}
			
			if (org.emailSupport) {
				emails.push({
					email: org.emailSupport,
					label: 'Support',
				});
			}
			
			return emails;
		},*/
		groupFilters() {
			// map value/option pairs to group data
			return this.org.organisationGroups.map(g => {
				return { value: g.id, option: g.name };
			});
		},
		filteredUsers() {
			// status filter
			let f1 = (this.statusFilter) ? this.users.filter(u => u.userOrganisations[0].status === this.statusFilter.value) : this.users.filter(u => u.userOrganisations[0].status !== 'archived');
			
			// group filter
			let f2 = (this.groupFilter) ? f1.filter(u => {
				return u.userOrganisations[0].userOrganisationGroups.find(g => g.organisationGroupId === this.groupFilter.value);
			}) : f1;
			
			// role filter
			let f3 = (this.roleFilter) ? f2.filter(u => u.userOrganisations[0].role.id === this.roleFilter.value) : f2;
			
			// mentor
			if (this.isMentor && !this.canManagePeople) {
				// mentor - so only show assigned learners
				f3 = (this.org.assignmentIndividual) ? f3.filter(u => u.userOrganisations[0].userOrganisationId === this.usr.id) : f3.filter(u => u.userOrganisations[0].role.slug === 'learner');
			}
			
			// serch term filter
			if (this.search) {				
				if (this.search.match(this.idRegex) !== null) {
					// id search
					const ids = this.search.split(',').map(id => { 
						return parseInt(id);
					});
					
					return f3.filter(u => ids.includes(u.id));
					
				} else {
					// name search
					return f3.filter(u => u.fullName.toLowerCase().includes(this.search.toLowerCase()));
				}
				
			} else {
				return f3;
			}					
		},
		previewUser() {
			return this.filteredUsers[this.previewIndex];
		}
	},
	methods: {
		hasFeature(feature, subfeature) {
			return this.$store.getters['gui/hasFeature'](feature, subfeature);
		},
		terminology(groupKey, termKey, varKey) {
			return this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
		},
		assignedMentor(user) {
			const userOrganisationId = user.userOrganisations[0].userOrganisationId;
			return (userOrganisationId) ? this.$store.getters['users/getUserByUserOrganisationId'](userOrganisationId) : null;
		},
		toggleCsv(bool) {
			this.csvImport = bool;
			this.$refs.formUsers.resetForm();			
			
			if (! bool) {
				this.csvData = null;
			}
		},
		setMenu(event) {
			if (event.target.nodeName === 'BUTTON' && event.relatedTarget.nodeName !== 'NAV') {
				const menu = event.target.nextSibling;
				menu.classList.remove('reverse');				
				const rect = menu.getBoundingClientRect();
				
				if (rect.bottom > window.innerHeight) {
					menu.classList.add('reverse');
				}
			}
		},
		userGroups(user) {
			return user.userOrganisations[0].userOrganisationGroups ? user.userOrganisations[0].userOrganisationGroups : null;
		},
		readFileAsync(file) {
			return new Promise((resolve, reject) => {
				let reader = new FileReader();
				
				reader.onload = () => {
					resolve(reader.result);
				};
				
				reader.onerror = reject;
				
				reader.readAsArrayBuffer(file);
			});
		},
		async onCsvChange(e) {
			try {
				this.csvData = null;
				this.$refs.formUsers.setFieldError('csv', '-'); // bug - needed for 
				
				const arrayBuffer = await this.readFileAsync(e.target.files[0]);
				
				// convert buffer to utf=8 string
				const decoder = new TextDecoder('utf-8');
				const str = decoder.decode(arrayBuffer);
				
				// cleanse whitespace
				const rows = str.trim().replace(/\r/g, '').split('\n');
				
				// validate column headers
				const keys = Object.keys(this.csvHeaders);
				const headers = rows[0].split(',').slice(0, keys.length);
				let i = 0;
				let invalidValue = false;
				let invalidOrder = false;
				
				for(let header in this.csvHeaders) {
					if (headers[i] !== header) {
						invalidValue = true;
						
						if (headers.includes(header)) {
							// valid header in wrong order
							invalidOrder = true;	
						}
						
						break;
					}
					i ++;
				}
				
				if (invalidValue) {
					if (invalidOrder) {
						this.$refs.formUsers.setFieldError('csv', 'Invalid column order');
						
					} else {
						this.$refs.formUsers.setFieldError('csv', 'Invalid column headers');						
					}
					
					return;
					
				} else {
					// set field as touched to enable invite button
					this.$refs.formUsers.setFieldTouched('csv', true);
				}
				
				// convert csv to object array
				let objs = rows.slice(1).map(row => {
					const cols = row.split(',');
					return Object.fromEntries(headers.map((h, i) => [h, cols[i]]))
				});
				
				if (!objs.length) {
					this.$refs.formUsers.setFieldError('csv', 'Missing row data');
					return;
					
				} else if (this.licenseLimit && (objs.length > this.licenseUnused)) {
					this.$refs.formUsers.setFieldError('csv', 'License allocation exceeded ('+this.licenseUnused+' unused)');
					return;
				}
				
				// validate data
				i = 0; // reset
				const emails = [];
				
				for (const row of objs) {
					try {
						i ++;
						
						if (emails.includes(row.email)) {
							this.$refs.formUsers.setFieldError('csv', 'Duplicate email: ' + row.email);
							return;
						}
						
						emails.push(row.email);
						
						// add username check
						row.allowUsername = this.allowUsername;
						
						// tidy values
						row.email = row.email.toLowerCase();
						row.forename = this.capitalise(row.forename); 
						row.surname = this.capitalise(row.surname); 						
						row.role = (!row.role) ? 'learner' : row.role.toLowerCase();						
						row.assignment = this.org.assignmentIndividual ? row.assignment.toLowerCase() : '';						
						
						if (!this.csvRoles.includes(row.role)) {
							// unknown role, check custom role names for match
							this.csvRoles.every((role) => {
								const term = this.terminology('user', role, 'singular').toLowerCase();
								
								if (term === row.role) {
									// assign correct role
									row.role = role;
									return false;
								}
								
								return true;
							});
						}
						
						await this.csvSchema.validate(row);
						
						// convert role slug to id
						row.roleId = this.roleFilters.find(r => r.slug === row.role).value;
						delete row.role;
						
						// convert requested mentor email to id (if valid)
						if (row.assignment && this.org.assignmentIndividual) {
							const mentor = this.mentors.find(m => m.email === row.assignment);
							
							if (mentor) {
								row.assignment = mentor.value // userOrganisation.id
							}
						}
						
					} catch (err) {
						let error = (err.errors[0] === 'invalid email or username' && !this.allowUsername) ? 'invalid email' : err.errors[0];
						
						error += ' for entry ' + i;
						
						this.$refs.formUsers.setFieldError('csv', error);
						return; // kill at first error
					}
				}
				
				// sort so mentors before learners
				objs.sort((a, b) => a.roleId - b.roleId);
				
				this.csvData = objs;
				
			} catch(err) {
				console.log(err);
			}
		},
		capitalise(word) {
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		},
		toggleModal(bool) {
			this.showModal = bool;
			
			if (this.showModal) {
				const form = this.$refs.formUsers;
				
				for(const field in form.getValues()) {
					let value = null;
					
					// preserve hidden field values
					if (field === 'allowUsername') {
						value = this.allowUsername;
						
					} else if (field === 'assignmentIndividual') {
						value = this.org.assignmentIndividual;						
					}
						
					form.resetField(field, {
						value,
					});
				}
				
				this.showTint();
				
				setTimeout(() => {
					if (this.org.assignmentAuto && this.mentors.length) {						
						// auto assign default
						const rand = Math.floor(Math.random() * this.mentors.length);
						this.assignment = this.mentors[rand].value;
					}
				}, 300);
				
			} else {
				this.hideTint();
				// await close animation
				setTimeout(() => {
					this.csvData = null;
				}, 300);
			}
		},
		showTint() {
			this.$store.dispatch('gui/setTintState', true);
		},
		hideTint() {
			this.$store.dispatch('gui/setTintState', false);
		},
		async suspendUser(user) {
			await this.$store.dispatch('users/dbSetStatus', {
				userId: user.id,
				status: 'suspended',
			});
		},
		unsuspendUser(user) {
			this.$store.dispatch('users/dbSetStatus', {
				userId: user.id,
				status: 'verified',
			});
		},
		archiveUser(user) {
			this.$store.dispatch('users/dbSetStatus', {
				userId: user.id,
				status: 'archived',
			});
		},
		unarchiveUser(user) {
			this.$store.dispatch('users/dbSetStatus', {
				userId: user.id,
				status: 'verified',
			});
		},
		async addUsers(values, actions) {
			try {
				this.disableInvite = true;
				
				let data = {
					from: this.emailUsers.find(u => u.email === values.from) || this.hqThinkHub,
				};
				
				delete values.from;
				
				if ('csv' in values) {
					// convert snake_case to camelCase
					data.to = this.csvData.map(d => {
						for(let key in d) {
							var newKey = key.replace(/_([a-z])/g, (str) => {
								return str[1].toUpperCase();
							});
							
							d[newKey] = d[key] ? d[key] : null; // empty to null
							
							if (newKey !== key) {
								// convereted so remove snake_case
								delete d[key];
							}
						}
						
						return d;
					});
					
				} else {
					// tidy values
					values.email = values.email.toLowerCase();
					values.forename = this.capitalise(values.forename); 
					values.surname = this.capitalise(values.surname); 						
					values.group = (values.group) ? this.capitalise(values.group) : null;
					values.assignment = (values.assignment) ? values.assignment : null;
					
					data.to = [values];				
				}
				
				await this.$store.dispatch('users/dbCreateUsers', data);
				
				this.toggleModal(false);
				
				this.disableInvite = false;
				
			} catch(err) {
				actions.setFieldError('email', err.response.data.message);
			}
		},
		async refreshUsers() {
			// load people from db
			await this.$store.dispatch('users/dbUsers');
		},
	},
}
</script>

<style lang="scss">
#peoplelist {
	.wrapper {
		display: flex;
		width: 100%;
		flex-grow: 1;
		.c1 {
			min-width: 290px;
		}
	}
	.license { // preview
		margin-bottom: 20px;
		.head {
			padding: 5px 20px;
		}
		.body {
			min-height: 0;
			padding: 0;
		}
		.numeric {
			margin-top: 1px;
			margin-bottom: 0;
			th {
				border-radius: 0;
			}
		}
		.but.sec {
			min-height: 26px;
			color: var(--pan-bar-col);
			border-color: var(--pan-bar-col);
		}
	}
}
@media (max-width: 960px) {
	#th.menu #peoplelist {
		.preview {
			display: none;
		}
	}
}
@media (max-width: 1160px) {
	#th:not(.menu) #peoplelist {
		.wrapper .c2 {
			display: none;
		}
	}
}
</style>
